export default __webpack_public_path__ + "static/media/tea_s.51f0254a.png";